module.exports = __webpack_public_path__ + "static/media/icon-relogio.6031de53.svg";